import styled, { css } from 'styled-components';

import { SearchSvg } from '../../../assets/icons';
import { IconWrapper } from '../../_atoms/IconWrapper';

const SearchInput = ({
  value,
  onChange,
  placeholder,
  className,
  icon = <SearchSvg />,
  onPressEnter,
  autoFocus,
  disabled,
  label,
  style,
  onBlur,
  type = 'text',
}: {
  value?: string;
  onChange: (val: string) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  icon?: React.ReactNode | null;
  className?: string;
  onPressEnter?: () => void;
  autoFocus?: boolean;
  style?: React.CSSProperties;
  onBlur?: () => void;
  type?: 'text' | 'number';
}) => {
  const handleKeyUp = (key: string) => {
    if (key === 'Enter') {
      onPressEnter && onPressEnter();
    }
  };
  return (
    <SearchInputContainer className={className}>
      {icon !== null && (
        <IconWrapper
          style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'default',
          }}
          className={className}
          height="20px"
          width="20px"
          color="#5B5B5A"
        >
          {icon}
        </IconWrapper>
      )}
      <div
        style={{ ...(style || {}), display: 'flex', flexWrap: 'wrap', margin: 'auto' }}
      >
        {label && (
          <span
            style={{
              color: '#a5a5a5',
              fontWeight: 'normal',
              marginBottom: '4px',
              fontSize: '12px',
            }}
          >
            {label}
          </span>
        )}
        <SearchInputComp
          type={type}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          className={className}
          onChange={e => onChange(e.target.value)}
          onKeyUp={e => handleKeyUp(e.key)}
          autoFocus={autoFocus}
          onBlur={onBlur}
          $hideIcon={icon === null}
        />
      </div>
    </SearchInputContainer>
  );
};

const SearchInputContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  margin: auto;
`;

const SearchInputComp = styled.input<{ $hideIcon?: boolean }>`
  border-radius: 5px;
  background: #f3f3f1;
  outline: none;
  border: none;
  height: 100%;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: auto;
  padding-left: 40px;
  font-weight: bold;
  color: #5b5b5a;
  ${({ $hideIcon }) =>
    $hideIcon === true &&
    css`
      padding-left: 10px;
    `}
`;

export default SearchInput;
